import type { TourFrame } from '@carboncopyco/types';
import type { TourState } from '../store';
import type { TourEditorState } from './tourEditorSlice';

export const hasInitialTourEditorState = (uuid: string) => (state: TourState) =>
  state.tourEditor.tours.hasOwnProperty(uuid);

export const selectActiveStepId = (uuid: string) => (state: TourState) =>
  state.tourEditor.tours[uuid].activeStepId;

export const selectActiveFrameId = (uuid: string) => (state: TourState) =>
  state.tourEditor.tours[uuid].activeFrameId;

export const selectAddingStepInProgress =
  (uuid: string) => (state: TourState) =>
    state.tourEditor.tours[uuid].addingStepInProgress;

export const selectIsGeneratingReplayFrameChunks =
  (uuid: string) => (state: TourState) =>
    state.tourEditor.tours[uuid].isGeneratingReplayFrameChunks;

export const selectIsApplyingTourTheme = (uuid: string) => (state: TourState) =>
  state.tourEditor.tours[uuid].isApplyingTourTheme;

export const selectIsSettingsModified = (uuid: string) => (state: TourState) =>
  state.tourEditor.tours[uuid].isSettingsModified;

export const selectFocusFrameIndex = (uuid: string) => (state: TourState) =>
  state.tourEditor.tours[uuid].focusFrameIndex;

export const selectIsScreenshotAsFrameUploading =
  (uuid: string) => (state: TourState) =>
    state.tourEditor.tours[uuid].isScreenshotAsFrameUploading;

export const selectCapturedScreenSize = (uuid: string) => (state: TourState) =>
  (state.tourEditor.tours[uuid] as TourEditorState).capturedScreenSize;

export const selectAspectRatio = (uuid: string) => (state: TourState) =>
  state.tourEditor.tours[uuid].aspectRatio;

export const selectPlayableFrames = (uuid: string) => (state: TourState) =>
  state.tourEditor.tours[uuid].playableFrames as TourFrame[];

export const selectDraftSettings = (uuid: string) => (state: TourState) =>
  (state.tourEditor.tours[uuid] as TourEditorState).draftSettings;

export const selectFramesWarnings = (uuid: string) => (state: TourState) =>
  (state.tourEditor.tours[uuid] as TourEditorState).framesWarnings;

export const selectFrameWarningsCount =
  (uuid: string, frameId: TourFrame['id']) => (state: TourState) => {
    let count = 0;

    const stepWarnings = (state.tourEditor.tours[uuid] as TourEditorState)
      .framesWarnings[frameId];

    for (const stepId in stepWarnings) {
      count += stepWarnings[stepId].length;
    }

    return count;
  };

export const selectIsMediaUploading = (uuid: string) => (state: TourState) =>
  (state.tourEditor.tours[uuid] as TourEditorState).isMediaUploading;
